import React from "react";
import Layout from "./Layout";
import { useNavigate } from "react-router-dom";

const Vip = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div>
        <div className="row no-gutters">
          <div className="depo-with-mobile-header text-left col col-12">
            <button
              onClick={() => navigate(-1)}
              type="button"
              className="v-icon notranslate bank-mobile-header-navArrow v-icon--link mdi mdi-chevron-left theme--light"
              style={{ "font-size": "36px" }}
            />
            <span
              className="align-center justify-center"
              style={{
                "-webkit-text-transform": "uppercase",
                "text-transform": "uppercase",
              }}
            >
              VIP Membership Details
            </span>
          </div>
        </div>
        <div className="row tier-level-row no-gutters">
          <div className="v-tabs tier-tab theme--light" grows>
            <div
              role="tablist"
              className="v-item-group theme--light v-slide-group v-slide-group--is-overflowing v-tabs-bar v-tabs-bar--is-mobile primary--text"
              data-booted="true"
            >
              <div className="v-slide-group__prev v-slide-group__prev--disabled">
                {/**/}
              </div>
              <div className="v-slide-group__wrapper">
                <div className="v-slide-group__content v-tabs-bar__content">
                  <div
                    className="v-tabs-slider-wrapper"
                    style={{ height: "2px", left: "0px", width: "90px" }}
                  >
                    <div className="v-tabs-slider" />
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="true"
                    role="tab"
                    className="v-tab v-tab--active"
                  >
                    VIP1
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP2
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP3
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP4
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP5
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP6
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP7
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP8
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP9
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP10
                  </div>
                  <div
                    tabIndex={0}
                    aria-selected="false"
                    role="tab"
                    className="v-tab"
                  >
                    VIP11
                  </div>
                </div>
              </div>
              <div className="v-slide-group__next v-slide-group__next--disabled">
                {/**/}
              </div>
            </div>
          </div>
          <div className="v-window v-item-group theme--light v-tabs-items">
            <div className="v-window__container" style={{}}>
              <div className="v-window-item v-window-item--active">
                <div className="tierdetail-divWrapper">
                  <div className="tierDetail-card v-card v-sheet v-sheet--outlined theme--light">
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>VIP Level</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>VIP1</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Deposit Upgrade Requirement</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>৳0</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Turnover Upgrade Requirement</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>৳0</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Auto Deposit Bonus %</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>3.00%</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>VIP Upgrade Bonus</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>৳0</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Deposit Coin %</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>1.00%</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Birthday Bonus</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>৳188</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Slots Daily Turnover Rebate (%)</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>0.00%</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Casino Table Turnover Rebate (%)</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>0.00%</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Crash Games Turnover Rebate (%)</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>0.00%</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>VIP Merchandise &amp; Special Gifts</span>
                      </div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>label.csSupport</span>
                      </div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Deposit &amp; Withdrawal Priority</span>
                      </div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>VIP Events &amp; Experiences</span>
                      </div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Exclusive Access to New Features</span>
                      </div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Dedicated VIP Manager</span>
                      </div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div
                        className="col-padding col col-12"
                        style={{
                          "-webkit-text-align": "center",
                          "text-align": "center",
                        }}
                      >
                        <span>Maintenance Requirements</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Monthly Turnover Required</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>Lifetime</span>
                      </div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8">
                        <span>Withdrawal Limit</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>Not allowed</span>
                      </div>
                    </div>
                    <div className="row no-gutters">
                      <div className="col-border col col-8">
                        <span>Membership Renewal</span>
                      </div>
                      <div className="col-padding col col-4">
                        <span>Lifetime</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Vip;
